 
<style>

    .example-full-width{
        width: 100%;
    }
    
    .img-profileDialog{
        width: 74px;
    }
    
    .profileDialogWrapper{
        text-align: center;
    }
    
    
    
    
    </style>
    
    <div class="container">

        <div class="vertical-center">
            <h3> Hello </h3> 
            <p> To activate a digital quarantine pass we need informations about you. </p>

       


        </div>
    </div>

   